import React, { Component } from 'react'
import http from 'src/helper/http'
import './index.less'
import langM from './lang'
import {
  setDocumentTitle,
  setUidToken,
  getlang,
  setlang,
  inject,
  observer,
  closeWebview
} from '../../../helper/devTools.js'
import localstorage from 'src/helper/localstorage'
import config from 'src/core/config'
import vs from '../../../helper/vconsole'
@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    // this.welfareStore = this.props.store.register('activity/welfare')
    setDocumentTitle('APP GAME')
  }
  state = {
    messageTxt: "",
    currentNum: 500,
    enoughTip: false,
    exchangeTip: false,
    popUpShow: false,
    uid: 0,
    accesstoken: '',
    typeStatus: 1,
    rankList: [],
    recordList: [],
    myRank: {},
    scrollParams: "0,30",
    hasMore: false,
    lang:langM.en,
    language:'en',
  }

  async initLang() {
    let { language } = this.props.location.query
    language =await getlang(language)
    this.setState({
      lang: setlang(language, langM),
      language: language,
    })
    console.log('language', language)
  }

  async initUid() {
    let uid = await setUidToken(this.props.location.query)
    console.log(uid, 'uid')
    return uid
  }
  
  async componentWillMount (){
    window.addEventListener(
      'message',
       async(e)=> {
        if (e.data && e.data != '') {
          try {
            let d = JSON.parse(e.data)
            if (d.msgtp == 'popRecharge') {
              return   
            }
            if (d.msgtp == 'popClose') return closeWebview()
          } catch (error) {
            console.error(error)
          }
        }
      },
      false
    )
  }
  
  async componentDidMount() {
    this.initLang()
    let uid = await this.initUid()
    await this.RunOnStart(uid)
  }

  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {

    const { uid:lguid, accesstoken } = localstorage.get('userInfo')
    this.setState({
      uid: uid||lguid,
      accesstoken: accesstoken,
    })

  }
  render() {
    /* 关羽拿大🔪 */
    let GameURL = 'https://cdn-web.hotgame.win/game/Box/half/?sdk=chatie&gameID=206'

    //测试环境
    if (config.host == "https://api-test.thechatie.com") {
      GameURL = 'https://www.hotgame.win/box/chatie_test/half?gameID=206'
    }
    let { tk } = this.props.location.query
    return (
      <div className={`game1`}>
          <iframe
            className="app-games-iframe"
            id='app-games-iframe-main'
            src={`${GameURL}&uid=${this.state.uid}&accesstoken=${tk}&lang=${this.state.language == "zh" ? "en" : this.state.language}`}
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture">
          </iframe>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/game-box/index.js